import React, { useState, useCallback } from 'react';
import EyeIcon from 'mdi-react/EyeIcon';
import DeleteIcon from 'mdi-react/DeleteIcon';
import { useDispatch } from 'react-redux';

import Modal from '@xcritical/modal';

import { IconButton } from '@crm-framework/icon-button';
import { Confirm } from '@crm-framework/confirm';

import { notificationsActions } from '../../NotificationsStore';
import { NotificationDetails } from '../notification-details';

import { INotificationActionsProps } from './types';
import { StyledNotificationActions } from './styles';

export const NotificationActions: React.FC<INotificationActionsProps> = ({
  notificationItem,
}) => {
  const dispatch = useDispatch();

  const [isDetailsOpened, setIsDetailsOpened] = useState(false);
  const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] = useState(false);

  const onViewDetails = useCallback(() => {
    const { id, isRead } = notificationItem.notificationDetails;

    setIsDetailsOpened(true);

    if (!isRead) {
      dispatch(
        notificationsActions.markAsRead({
          ids: [id],
        })
      );
    }
  }, [dispatch, notificationItem.notificationDetails]);

  const onCloseDetails = useCallback(() => {
    setIsDetailsOpened(false);
  }, []);

  const onShowDeleteConfirm = useCallback(() => {
    setIsConfirmDeleteOpen(true);
  }, []);

  const onDeleteConfirmed = useCallback(() => {
    setIsConfirmDeleteOpen(false);
    dispatch(
      notificationsActions.delete({
        ids: [notificationItem.notificationDetails.id],
      })
    );
  }, [dispatch, notificationItem.notificationDetails.id]);

  const onDeleteConfirmCancel = useCallback(() => {
    setIsConfirmDeleteOpen(false);
  }, []);

  return (
    <>
      <StyledNotificationActions>
        <IconButton
          icon={EyeIcon}
          withCircleHover
          appearance="default"
          onClick={onViewDetails}
        />
        <IconButton
          icon={DeleteIcon}
          withCircleHover
          appearance="default"
          onClick={onShowDeleteConfirm}
        />
      </StyledNotificationActions>

      <NotificationDetails
        isOpen={isDetailsOpened}
        notificationItem={notificationItem}
        onCancel={onCloseDetails}
      />

      <Modal
        name="notification-delete-confirmation"
        title="Notification delete confirmation"
        isOpen={isConfirmDeleteOpen}
        onModalCancel={onDeleteConfirmCancel}>
        <Confirm onOk={onDeleteConfirmed} onCancel={onDeleteConfirmCancel}>
          Do you really want to delete this notification?
        </Confirm>
      </Modal>
    </>
  );
};
